import styled from '@emotion/styled'

export const PageFrame = styled.div`
  .report-card {
    border: 1px solid var(--kt-gray-200, #eff2f5);
    border-radius: 14px;
    background: var(--kt-body-bg, #fff);
    box-shadow: 0 4px 20px rgba(24, 28, 50, 0.03);
  }
  .report-heading {
    padding: 24px;
    border-bottom: 1px solid var(--kt-gray-200, #eff2f5);
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 18px;
  }
  .report-title {
    display: flex;
    align-items: center;
    gap: 13px;
  }
  .report-title-icon {
    display: grid;
    place-items: center;
    width: 44px;
    height: 44px;
    border-radius: 12px;
    color: var(--kt-primary, #009ef7);
    background: var(--kt-primary-light, #f1faff);
    flex-shrink: 0;
  }
  h1 {
    font-size: 19px;
    font-weight: 600;
    margin: 0;
    color: var(--kt-gray-900, #181c32);
  }
  .report-caption {
    font-size: 12px;
    color: var(--kt-gray-500, #a1a5b7);
    margin: 5px 0 0;
  }
  .report-actions {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
  }
  .report-actions .btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
    padding: 10px 13px;
    border-radius: 8px;
    font-size: 13px;
  }
  .report-limit {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .report-limit label {
    font-size: 12px;
    color: var(--kt-gray-600, #7e8299);
  }
  .report-limit select {
    width: 90px;
    min-height: 39px;
    border-radius: 8px;
    font-size: 13px;
  }
  .report-body {
    padding: 20px 24px 24px;
  }
  .report-summary {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 18px;
    margin-bottom: 16px;
    font-size: 12px;
    color: var(--kt-gray-600, #7e8299);
  }
  .report-summary strong {
    color: var(--kt-gray-800, #3f4254);
    font-weight: 600;
    margin-left: 4px;
  }
  .report-state {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
    min-height: 310px;
    gap: 12px;
    color: var(--kt-gray-600, #7e8299);
  }
  .report-state > svg {
    color: var(--kt-gray-400, #b5b5c3);
  }
  .report-state h2 {
    font-size: 16px;
    color: var(--kt-gray-800, #3f4254);
    margin: 0;
  }
  .report-state p {
    margin: 0;
    font-size: 13px;
  }
  .report-state .spinner-border {
    width: 32px;
    height: 32px;
    margin-bottom: 6px;
  }
  .report-tabs {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    border-bottom: 1px solid var(--kt-gray-200, #eff2f5);
    margin: 0 0 18px;
  }
  .report-tabs button {
    border: 0;
    border-bottom: 2px solid transparent;
    padding: 0 2px 12px;
    background: transparent;
    color: var(--kt-gray-600, #7e8299);
    font-size: 13px;
    font-weight: 500;
  }
  .report-tabs button[aria-selected='true'] {
    color: var(--kt-primary, #009ef7);
    border-bottom-color: var(--kt-primary, #009ef7);
  }
  .report-tabs button:focus-visible {
    outline: 2px solid var(--kt-primary, #009ef7);
    outline-offset: 2px;
  }
  .report-error {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }
  .report-error .btn {
    margin-left: auto;
  }
  .missing svg {
    color: var(--kt-danger, #f1416c);
  }
  @media (max-width: 650px) {
    .report-heading,
    .report-body {
      padding: 16px;
    }
    .report-title-icon {
      display: none;
    }
    h1 {
      font-size: 17px;
    }
    .report-actions {
      gap: 8px;
    }
    .report-actions .btn {
      padding: 9px 11px;
    }
  }
`
